import React, { useState } from "react";
import { API } from "@/lib/api";

export const Avatar = ({
  userId,
  name,
  email,
  hasAvatar,
  version,
  className = "w-10 h-10",
  textClassName = "text-sm",
  rounded = "rounded-full",
  testid,
}) => {
  const [err, setErr] = useState(false);
  const initial = (name || email || "U")[0].toUpperCase();
  const show = hasAvatar && !err && userId;

  return (
    <div
      data-testid={testid}
      className={`${className} ${rounded} overflow-hidden bg-gradient-to-br from-emerald-500 to-teal-400 flex items-center justify-center text-black font-display font-black ${textClassName} shrink-0`}
    >
      {show ? (
        <img
          src={`${API}/avatars/${userId}?v=${encodeURIComponent(version || "")}`}
          alt={name || "avatar"}
          className="w-full h-full object-cover"
          onError={() => setErr(true)}
        />
      ) : (
        initial
      )}
    </div>
  );
};
